import { registerPlugin } from '@wordpress/plugins';

const render = () => {};

registerPlugin('sc-woo-slot-fills', {
    render,
    scope: 'woocommerce-checkout',
});
